import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { GalleryGridWithDescriptionCap } from '../../../../Utils/Constants'
import DescriptionMyGallery from './DescriptionMyGallery'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const GalleryGridDescContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardHeaderCommon title={GalleryGridWithDescriptionCap} />
            <CardBody className="my-gallery gallery-with-description">
              <Row>
                <DescriptionMyGallery />
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default GalleryGridDescContainer